import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "./routes/AppRoutes";
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <div className="relative z-10 flex min-h-svh min-w-0 w-full flex-1 flex-col">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <AppRoutes />
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
